import { useNavigate } from "react-router-dom";

import { getCreateContractRoute, getServiceRequestPageRoute } from "../../../routers/routeUtils";

import { ServiceRequest } from "../types/service.type";
import { useRequestService } from "../api/mutations/useRequestService";
import { useRespondToContract } from "../api/mutations/useRespondToContract";
import { useCancelServiceRequest } from "../api/mutations/useCancelServiceRequest";
import { useProviderCancelServiceRequest } from "../api/mutations/useProviderCancelServiceRequest";

export const useServiceRequestActions = (serviceRequest: ServiceRequest, contractId?: number) => {
  const navigate = useNavigate();

  const { mutate: respondToContract, isPending: isResponding } = useRespondToContract(
    serviceRequest.id,
    contractId || serviceRequest.contractId!
  );
  const { mutate: providerCancel, isPending: isCancellingByProvider } = useProviderCancelServiceRequest(
    serviceRequest.id
  );
  const { mutate: requestService, isPending: isRequesting } = useRequestService(serviceRequest.service.id);
  const { mutate: requesterCancel, isPending: isWithdrawing } = useCancelServiceRequest(serviceRequest.id!);

  return {
    isResponding,
    isRequesting,
    isCancellingByProvider,
    isWithdrawing,

    handleAcceptContract: () => {
      if (serviceRequest.id && (contractId || serviceRequest.contractId)) {
        respondToContract("approved");
      }
    },

    handleEndContract: () => {
      if (serviceRequest.id && (contractId || serviceRequest.contractId)) {
        respondToContract("denied");
      }
    },

    handleProviderCancel: () => {
      if (serviceRequest.id) {
        providerCancel();
      }
    },

    handleRequestService: () => {
      if (serviceRequest.service.id) {
        requestService();
      }
    },

    handleWithdrawRequest: () => {
      if (serviceRequest.id) {
        requesterCancel();
      }
    },

    handleCreateContract: () => {
      navigate(getCreateContractRoute(serviceRequest.id, serviceRequest.service.id));
    },

    handleNegotiateContract: () => {
      navigate(getServiceRequestPageRoute(serviceRequest.id, "chat"));
    },
  };
};
